import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const StaffEmploymentService = {
  getAllJobs(obj) {
    return httpClient.post(endPoints.getJobs, obj);
  },
  getAllStaffgrades(obj) {
    return httpClient.post(endPoints.getStaffgrades, obj);
  },
  getAllEmployStatus(obj) {
    return httpClient.post(endPoints.getEmployStatus, obj);
  },
  addEmployStatus(obj) {
    return httpClient.post(endPoints.addEmployStatus, obj);
  },
  updateEmployStatus(obj) {
    return httpClient.post(endPoints.updateEmployStatus, obj);
  },
  deleteEmployStatus(obj) {
    return httpClient.post(endPoints.deleteEmployStatus, obj);
  },
  getAllDepartment(obj) {
    return httpClient.post(endPoints.getDepartments, obj);
  },
  addDepartment(obj) {
    return httpClient.post(endPoints.addDepartment, obj);
  },
  updateDepartment(obj) {
    return httpClient.post(endPoints.updateDepartment, obj);
  },
  deleteDepartments(obj) {
    return httpClient.post(endPoints.deleteDepartments, obj);
  },
  getAllTeams(obj) {
    return httpClient.post(endPoints.getTeams, obj);
  },
  addTeam(obj) {
    return httpClient.post(endPoints.addTeam, obj);
  },
  updateTeam(obj) {
    return httpClient.post(endPoints.updateTeam, obj);
  },
  deleteTeams(obj) {
    return httpClient.post(endPoints.deleteTeams, obj);
  },
  getAllSourceOfApps(obj) {
    return httpClient.post(endPoints.getSourceOfApps, obj);
  },
  getAllBenefit(obj) {
    return httpClient.post(endPoints.getBenefits, obj);
  },
};

export default StaffEmploymentService;



// WEBPACK FOOTER //
// ./src/service/StaffEmploymentService.js